import React from 'react';
import PasswordStrengthMeter from '../../../../../../../components/password-strength-meter';
import styled from '@emotion/styled';
import { useField } from 'formik';
import InputPassword from '../../../../../../../components/form/parts/InputPassword';
import InputText from '../../../../../../../components/form/parts/InputText';
import FieldWrapper from '../FieldWrapper';
import ErrorMessage from '../../../../../../../components/form/parts/ErrorMessage';
import FieldValueDragWrapper from './FieldValueWrapper';

function PasswordField(props) {
    const [field, meta] = useField(props);

    return (
        <FieldWrapper {...props}>
            <StyledLabel
                htmlFor={props.id || props.name}
                hasInputField={props.categoryFieldId === null ? true : false}
            >
                {props.categoryFieldId === null ? (
                    <>
                        <InputText
                            {...props}
                            name={`${props.name}.label`}
                            placeholder={'Label'}
                        />
                        {meta.touched && meta.error && meta.error.label ? (
                            <ErrorMessage>{meta.error.label}</ErrorMessage>
                        ) : null}
                    </>
                ) : (
                    props.label
                )}
            </StyledLabel>
            <StyledDisplayText>
                <FieldValueDragWrapper {...props} accept={'passwordField'}>
                    <InputPassword
                        {...props}
                        name={`${props.name}.valueEncrypted`}
                        placeholder={'Waarde'}
                        autoComplete={'new-password'}
                    />
                </FieldValueDragWrapper>
                <PasswordStrengthMeter password={field.value.valueEncrypted} />
            </StyledDisplayText>
        </FieldWrapper>
    );
}

export default PasswordField;

/* --- START STYLING --- */
const StyledLabel = styled.label`
    flex: 2;
    text-align: end;
    padding: ${props => (props.hasInputField ? '0.4' : '1.2')}rem 0.8rem;
    color: ${props => props.theme.colors.textGrey};
`;

const StyledDisplayText = styled.div`
    flex: 4;
    padding: 0.4rem;
    color: ${props => props.theme.colors.textDefault};
`;
/* --- END STYLING --- */
